import {createGlobalStyle} from 'styled-components'
import 'rsuite/dist/rsuite.min.css'

const GlobalStyle = createGlobalStyle`
  body {
    position: relative;
    margin: 0px;
    padding: 0px;
    height: 100vh;
    width: 100vw;
    font-family: Poppins, sans-serif;
  }
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }
  #sightcall-root {
    width: 100%;
    height: 100%;
  }
  .draggable {
    top: auto !important;
    left: auto !important;
  }
  *::-webkit-scrollbar {
    display: none;
    scrollbar-width: 'none';
    -ms-overflow-style: 'none';
  }
`

export default GlobalStyle
